import React from 'react';
import styled from 'styled-components';

// Rodape institucional da LP da Bianca (abianca.com.br).
// Alem da funcao usual, ele existe pra atender a exigencia da Meta na
// "Verificacao do acesso" de provedor de tecnologia: o site publico precisa
// mostrar o servico prestado, os dados da empresa que o fornece e os links
// legais. Nao remover CNPJ/razao social sem alinhar com essa verificacao.

const APP_URL = 'https://app.abianca.com.br';

const FooterContainer = styled.footer`
  position: relative;
  z-index: 3;
  background: linear-gradient(180deg, #000c24 0%, #00060f 100%);
  border-top: 1px solid rgba(64, 128, 255, 0.25);
  color: rgba(255, 255, 255, 0.72);
  font-family: 'Inter', 'Roboto', sans-serif;
  padding: 56px 24px 32px;
`;

const FooterInner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 40px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const Brand = styled.div`
  .brand-name {
    font-family: 'Orbitron', sans-serif;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.18em;
    color: #ffffff;
    margin-bottom: 12px;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.7;
    max-width: 420px;
  }
`;

const Column = styled.div`
  h3 {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(120, 170, 255, 0.9);
    margin: 0 0 14px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.5;
  }

  a {
    color: rgba(255, 255, 255, 0.72);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #4080ff;
    }
  }
`;

const LegalBar = styled.div`
  max-width: 1080px;
  margin: 40px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  justify-content: space-between;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);

  strong {
    color: rgba(255, 255, 255, 0.72);
    font-weight: 600;
  }
`;

const SiteFooter = () => {
  const year = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterInner>
        <Brand>
          <div className="brand-name">BIANCA</div>
          <p>
            Plataforma de software (SaaS) para imobiliárias, incorporadoras e times comerciais.
            A assistente virtual com inteligência artificial atende os leads da empresa por
            WhatsApp e telefone em segundos, agenda visitas com os corretores e organiza as
            campanhas de anúncios e o funil de vendas em um único painel.
          </p>
        </Brand>

        <Column>
          <h3>Plataforma</h3>
          <ul>
            <li>
              <a href={APP_URL} target="_blank" rel="noopener noreferrer">
                Acessar o painel
              </a>
            </li>
            <li>
              <a href="mailto:contato@abianca.com.br">contato@abianca.com.br</a>
            </li>
            <li>
              <a href="mailto:privacidade@abianca.com.br">privacidade@abianca.com.br</a>
            </li>
          </ul>
        </Column>

        <Column>
          <h3>Legal</h3>
          <ul>
            <li>
              <a href={`${APP_URL}/privacidade`} target="_blank" rel="noopener noreferrer">
                Política de Privacidade
              </a>
            </li>
            <li>
              <a href={`${APP_URL}/termos`} target="_blank" rel="noopener noreferrer">
                Termos de Serviço
              </a>
            </li>
            <li>
              <a href={`${APP_URL}/exclusao-de-dados`} target="_blank" rel="noopener noreferrer">
                Exclusão de dados
              </a>
            </li>
          </ul>
        </Column>
      </FooterInner>

      <LegalBar>
        <span>
          <strong>BIANCA COMPANY LTDA</strong> · CNPJ 47.216.954/0001-08
        </span>
        <span>© {year} Bianca. Todos os direitos reservados.</span>
      </LegalBar>
    </FooterContainer>
  );
};

export default SiteFooter;
